import React from 'react';
import type { GetServerSidePropsContext } from 'next';

import LoadingSpinnerCenter from '~/components/LoadingSpinnerCenter';
import { TrackPage } from '~/components/TrackEvent';
import { getSnowdonJwt } from '~/domains/auth/utils';
import ShoppingCartLink from '~/domains/cart/ShoppingCartLink';
import BaseLayout from '~/layouts/BaseLayout';
import { prefetchReactQueryData } from '~/libs/reactQuery';
import type { NextPageWithLayout } from '~/types';

import { MypageContainer } from './components/MypageContainer';

const MyPage: NextPageWithLayout = () => {
  return (
    <>
      <TrackPage page="마켓/마이페이지" />
      <MypageContainer />
    </>
  );
};

MyPage.Layout = function Layout({ children }: { children: React.ReactNode }) {
  return (
    <BaseLayout title="마켓 마이페이지" right={<ShoppingCartLink />}>
      <React.Suspense fallback={<LoadingSpinnerCenter />}>
        {children}
      </React.Suspense>
    </BaseLayout>
  );
};

export default MyPage;

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  const token = getSnowdonJwt(context) || null;

  if (!token) {
    return {
      props: {},
    };
  }

  const { dehydratedState } = await prefetchReactQueryData({
    queries: [
      '/api/market-place/v1/frequently-order/products', // 자주구매한 상품 리스트
      '/api/market-place/v1/buyer/plus-membership', // 멤버십 정보 조회
      '/api/market-place/v1/buyer/my-page', // /mypage 에 노출될 정보 조회
    ],
    fetchOptions: {
      headers: {
        'X-Client-Auth-Token': token,
      },
    },
  });

  return {
    props: {
      dehydratedState,
    },
  };
};
